import env from 'env'

export const changeEmail = ({ email, password }) => ({
  type: 'api/userSettings/CHANGE_EMAIL',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/me/email',
      method: 'PUT',
      data: {
        email,
        password,
      },
    },
  },
})
changeEmail.toString = () => 'api/userSettings/CHANGE_EMAIL'

export const changePassword = ({ currentPassword, newPassword }) => ({
  type: 'api/userSettings/CHANGE_PASSWORD',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/accounts/me/password',
      method: 'PUT',
      data: {
        currentPassword,
        newPassword,
      },
    },
  },
})
changePassword.toString = () => 'api/userSettings/CHANGE_PASSWORD'
